import { jsx as g } from "react/jsx-runtime";
import { BadRequest as h } from "@systemeio/util";
import E from "../../../ui-kit/theme-button.mjs";
import { useStripe as P, useElements as T } from "../../../node_modules/@stripe/react-stripe-js/dist/react-stripe.esm.mjs";
import { useStore as j } from "../../../store/index.mjs";
import { stripeBuyOffer as q } from "../api/stripe-api.mjs";
import { twJoin as x } from "tailwind-merge";
import { IntentTypeEnum as D } from "../enum/intent-type-enum.mjs";
function A({
  isFetching: s,
  buttonTitle: c,
  buttonDisabled: f,
  setErrors: l,
  setIsFetching: o,
  preSubmit: u,
  handleBadRequest: p,
  hasErrors: d
}) {
  const { locale: y } = j(), t = P(), r = T(), b = async (w) => {
    if (w.preventDefault(), !(!t || !r)) {
      o(!0);
      try {
        const e = u();
        if (!e) return;
        const { error: B } = await r.submit();
        if (B) return;
        const { redirect: n, intentSecret: i, intentType: S } = await q(e, y);
        if (!i) return window.location.href = n;
        const _ = S === D.setup ? t.confirmSetup : t.confirmPayment, { error: m } = await _({
          elements: r,
          clientSecret: i,
          confirmParams: {
            payment_method_data: {
              billing_details: {
                name: [e.customer.fields.first_name, e.customer.fields.last_name].filter(Boolean).join(" "),
                email: e.customer.fields.email
              }
            },
            return_url: n
          }
        });
        m && l((a) => ({ ...a, common: [...a.common, m.message] }));
      } catch (e) {
        if (e instanceof h)
          p(e);
        else
          throw e;
      } finally {
        o(!1);
      }
    }
  };
  return /* @__PURE__ */ g(
    E,
    {
      disabled: f,
      className: x("main-transition-colors", d && "bg-danger focus:bg-danger"),
      onClick: b,
      isFetching: s,
      type: "submit",
      children: c
    }
  );
}
export {
  A as RedirectBasedPaymentButton
};
